import store from '../store';
import { buttonsActions, IButton } from '../store/buttonsSlice';

export default class ActionButton {
  constructor(public id: string) {}

  #getProp(name: keyof IButton) {
    return store.getState().buttonsSlice.buttons[this.id][name];
  }

  set label(label: string) {
    this.#update({ label });
  }

  get label() {
    return this.#getProp('label') as string;
  }

  set title(title: string) {
    this.#update({ title });
  }

  get title() {
    return this.#getProp('title') as string;
  }

  set variant(variant: string) {
    this.#update({ variant });
  }

  get variant() {
    return this.#getProp('variant') as string;
  }

  disable() {
    this.#update({ disabled: true });
  }

  enable() {
    this.#update({ disabled: false });
  }

  hide() {
    this.#update({ hidden: true });
  }

  show() {
    this.#update({ hidden: false });
  }

  #update(props: Partial<IButton>) {
    store.dispatch(buttonsActions.updateButton({ id: this.id, ...props }));
  }

  static BTN_VIEW_DOCS = 9;

  static BTN_CLOSE = 10;

  static BTN_CONFIRM = 0;

  static BTN_DELEGATE = 6;

  static BTN_NEXT = 1;

  static BTN_PRINT = 8;

  static BTN_PREV = 2;

  static BTN_RELEASE = 5;

  static BTN_SAVE = 4;

  static BTN_SIGN = 3;

  static BTN_SHARE = 7;
}
